require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./structure-des-tudes-bachelor-2-1-0.json") })
        }
      }, "path---structure-des-tudes-bachelor-2-1-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---structure-des-tudes-bachelor-2-1-0!./.cache/json/structure-des-tudes-bachelor-2-1-0.json
// module id = 578
// module chunks = 231608221292675